module.exports = __webpack_public_path__ + "img/logo-4.e2674e91.png";